module.exports = __webpack_public_path__ + "img/empire seam.f5568eda.png";